/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Import_Stat_PropertiesInputs */

const cs_import_stat_properties = /** @type {(inputs: Import_Stat_PropertiesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nemovitosti: ${i?.count}`)
};

const en_import_stat_properties = /** @type {(inputs: Import_Stat_PropertiesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Properties: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Properties: {count}" |
*
* @param {Import_Stat_PropertiesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_stat_properties = /** @type {((inputs: Import_Stat_PropertiesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Stat_PropertiesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_stat_properties(inputs)
	return cs_import_stat_properties(inputs)
});